export default __webpack_public_path__ + "assets/41c980.svg";